import * as yup from "yup";

export interface MediaUploadData {
    fileName: string;
    guid: string;
    size?: number;
    url?: string;
}

export const MediaUploadSchema = yup.object<MediaUploadData>().shape({
    fileName: yup.string().label("$parent file name"),
    guid: yup.string().label("$parent media GUID"),
    size: yup.number().label("$parent file size"),
    url: yup.string().label("$parent file URL"),
});

export const MediaUploadRequiredSchema = yup.object<MediaUploadData>().shape({
    fileName: yup.string().max(255),
    guid: yup.string().required("$parent is required").min(36, "$parent is not valid").max(36, "$parent is not valid"),
    size: yup.number(),
    url: yup.string(),
}).concat(MediaUploadSchema);



// WEBPACK FOOTER //
// ./src/forms/upload/MediaUpload.ts